import { useTranslation } from "react-i18next";
import { Coins } from "lucide-react";

export default function PackageCard({ pkg, onBuy }) {
  const { t } = useTranslation();
  const dollars = (pkg.price_cents / 100).toFixed(2).replace(/\.00$/, "");
  return (
    <div
      data-testid={`package-card-${pkg.id}`}
      className={`
        relative rounded-2xl p-4 flex flex-col gap-3 min-w-[150px]
        ${pkg.best_value
          ? "bg-[rgba(0,229,255,0.05)] border border-[rgba(0,229,255,0.45)]"
          : "bg-white/[0.025] border border-white/[0.07]"}
      `}
    >
      {pkg.best_value ? (
        <span className="absolute -top-2 right-3 text-[9px] uppercase tracking-[0.18em] px-2 py-0.5 rounded-full bg-[rgba(0,229,255,0.18)] border border-[rgba(0,229,255,0.55)] text-[#00E5FF]">
          {t("billing.tiers.popular")}
        </span>
      ) : null}
      <div className="flex items-center gap-2">
        <Coins className="h-4 w-4 text-[#00E5FF]" strokeWidth={1.75} />
        <p className="text-[16px] font-semibold text-[#E5E7EB] font-mono">
          {pkg.tokens.toLocaleString()}
        </p>
      </div>
      <p className="text-[11.5px] text-[#9CA3AF] -mt-2">NexaTokens</p>
      <p
        data-testid={`package-price-${pkg.id}`}
        className="text-[20px] font-semibold text-[#E5E7EB] font-mono leading-none"
      >
        ${dollars}
      </p>
      <button
        type="button"
        onClick={() => onBuy(pkg)}
        data-testid={`package-buy-${pkg.id}`}
        className="mt-1 h-9 rounded-full text-[12px] font-semibold bg-[rgba(0,229,255,0.14)] border border-[rgba(0,229,255,0.5)] text-[#00E5FF] hover:bg-[rgba(0,229,255,0.22)]"
      >
        {t("billing.packages.buy")}
      </button>
    </div>
  );
}
